import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
const LogoSVG = require("@/assets/Logo06.PNG");

const Logo = () => {
  const navigate = useNavigate();
  const onClickHandler = useCallback(() => {
    navigate("/");
  }, [navigate]);
  return <LogoComponent name={LogoSVG} onClick={onClickHandler} />;
};

export default Logo;

export const LogoComponent = styled.div<{ name: string }>`
  background-image: url(${(props) => props.name});
  background-position: center;
  background-size: cover;
  width: 150px;
  height: 150px;
  margin: 0 1rem;
  cursor: pointer;
`;
